"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _lodash = _interopRequireDefault(require("lodash"));

var _logger = _interopRequireDefault(require("../utils/logger"));

/**
 * @fileoverview Singleton service responsible for reporting errors and user actions to datadog monitoring.
 */
var ERROR_PREFIX = '[amp-realtime-error]';
var WARNING_PREFIX = '[amp-realtime-warning]';
var ACTION_PREFIX = '[amp-realtime-action]';

var getContext = function getContext(channelOrChannels) {
  if (_lodash.default.isString(channelOrChannels)) {
    return {
      channel: channelOrChannels
    };
  } else if (Array.isArray(channelOrChannels)) {
    return {
      channels: channelOrChannels
    };
  }
};

var getLogMessage = function getLogMessage(message, channel) {
  return _lodash.default.isString(channel) ? "".concat(message, " in channel ").concat(channel) : message;
};

var MonitoringService = /*#__PURE__*/function () {
  function MonitoringService() {
    (0, _classCallCheck2.default)(this, MonitoringService);
    (0, _defineProperty2.default)(this, "datadogRum", void 0);
  }

  (0, _createClass2.default)(MonitoringService, [{
    key: "setDatadogRum",
    value: // note datadogRum is dynamically set like this so that it doesn't have to
    // be a dependency and can be an optional binding from the client
    function setDatadogRum(datadogRum) {
      this.datadogRum = datadogRum;
    }
  }, {
    key: "reportError",
    value: function reportError(errorMessage, channel) {
      var context = getContext(channel);

      if (this.datadogRum) {
        this.datadogRum.addError(new Error("".concat(ERROR_PREFIX, " ").concat(errorMessage)), context);
      }

      _logger.default.error(getLogMessage(errorMessage, channel));
    }
  }, {
    key: "reportWarning",
    value: function reportWarning(warningMessage, channel) {
      var context = getContext(channel);

      if (this.datadogRum) {
        this.datadogRum.addAction("".concat(WARNING_PREFIX, " ").concat(warningMessage), context);
      }

      _logger.default.warn(getLogMessage(warningMessage, channel));
    }
  }, {
    key: "reportAction",
    value: function reportAction(message, channelOrChannels, logMessage) {
      var context = getContext(channelOrChannels);

      if (this.datadogRum) {
        this.datadogRum.addAction("".concat(ACTION_PREFIX, " ").concat(message), context);
      }

      _logger.default.info(logMessage || getLogMessage(message, channelOrChannels));
    }
  }]);
  return MonitoringService;
}();

var _default = new MonitoringService();

exports.default = _default;
//# sourceMappingURL=monitoringService.js.map